import { atom, useRecoilValue } from 'recoil'

export type PermissionFuncInfo = {
    functionID: number
    functionName_th: number
    functionName_en: number
}

export type ProfileType = {
    academicPositionID: number | null
    academicPositionName_en: string | null
    academicPositionName_th: string | null
    academicPositionOther: string | null
    email: string | null
    facultyID: number | null
    facultyName_en: string | null
    facultyName_th: string | null
    fax: string | null
    homePhone: string | null
    irb: number | null
    mobilePhone: string | null
    name_en: string | null
    name_th: string | null
    titleNameID: number | null
    titleNameOther: string | null
    titleName_en: string | null
    titleName_th: string | null
    userGroupId: number | null
    userGroupName_en: string | null
    userGroupName_th: string | null
    userId: number | null
    username: string | null
    image_path: string | null
    permission: Array<PermissionFuncInfo>
    isPhD: boolean | null
    only_name_en: string | null
    only_name_th: string | null
    isCunet: boolean | null
    titleNameOther_th: string | null
    titleNameOther_en: string | null
    academicPositionOther_th: string | null
    academicPositionOther_en: string | null
}

export type AuthenStoreType = {
    profile: ProfileType
}
export const authenStore = atom<AuthenStoreType>({
    key: 'authenStore',
    default: {
        profile: {
            academicPositionID: null,
            academicPositionName_en: null,
            academicPositionName_th: null,
            academicPositionOther: null,
            email: null,
            facultyID: null,
            facultyName_en: null,
            facultyName_th: null,
            fax: null,
            homePhone: null,
            irb: null,
            mobilePhone: null,
            name_en: null,
            name_th: null,
            titleNameID: null,
            titleNameOther: null,
            titleName_en: null,
            titleName_th: null,
            userGroupId: null,
            userGroupName_en: null,
            userGroupName_th: null,
            userId: null,
            username: null,
            image_path: null,
            permission: [],
            isPhD: null,
            only_name_en: null,
            only_name_th: null,
            isCunet: null,
            titleNameOther_th: null,
            titleNameOther_en: null,
            academicPositionOther_th: null,
            academicPositionOther_en: null,
        },
    },
})

const useAuthenStore = () => {
    const authenState = useRecoilValue(authenStore)
    return {
        ...authenState,
    }
}

export default useAuthenStore
